var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',_vm._l((_vm.cardsName),function(cardName){return _c('v-col',{key:cardName,attrs:{"cols":"12","md":"6"}},[_c('FooterCard',{attrs:{"cardName":cardName}})],1)}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }